<template>
  <product-card v-bind="forwarded">
    <template #badge v-if="$feature.tempShowTryItOnCtaForEachImageInGallery">
      <div class="absolute bottom-0 left-0 m-3 f-col items-start gap-4 lg:m-6">
        <base-button
          v-if="(productHasTryItOnAsset && $feature.showTryItOnCtaOnPDP)"
          id="pdp-try-it-on"
          class="body-4 flex center gap-1 rounded-xs bg-white/70 p-1 c-black shadow-sm backdrop-blur-md lg:gap-2 lg:p-2"
          @click="tryItOn"
        >
          <vf-icon name="try-it-on" />
          <span>{{ $t.tryItOn }}</span>
        </base-button>
      </div>
    </template>
    <template #tryItOn v-if="$feature.tempShowTryItOnCtaForEachImageInGallery">
      <dialog-try-it-on class-content="<md:h-full" />
    </template>
  </product-card>
</template>

<script lang="ts" setup>
import type { Props } from '#brand/components/product/card/Card.vue'
import ProductCard from '#brand/components/product/card/Card.vue'

const props = defineProps<Props>()
const forwarded = useForwardProps(props)

const { dialogOptions } = useAppConfig().pages.pdp.tryItOn || {}
const DialogTryItOn = createDialog('try-it-on', dialogOptions)
const { $gtm, $feature } = useNuxtApp()

const tryItOn = () => {
  $gtm.push('plpPage.onTryItOn')
  if (props.product.id) DialogTryItOn.open({ productId: props.product.id })
}

const tryItOnProducts = $feature.tempShowTryItOnCtaForEachImageInGallery
  ? (await import('#brand/assets/vyking-products.json')).default
  : []

const productHasTryItOnAsset = computed(() => tryItOnProducts.includes(props.product?.id?.toLowerCase()))
</script>
